import React, { FunctionComponent } from 'react';
import {
  ImageLinkModel,
  PrimaryLinkModel,
  SecondaryLinkModel,
  SecondaryLinkWithBoldModel,
  TMenuLinkModel,
} from '../navigationItem/models/navigationItem.model';
import PrimaryLink from './primaryLink';
import SecondaryLink from './secondaryLink';
import SecondaryLinkWithBold from './secondaryLinkWithBold';
import ImageLink from './imageLink';

const MenuLink: FunctionComponent<{ model: TMenuLinkModel; onClick: () => void; menuTitle?: string }> = ({ model, onClick, menuTitle }) => {
  if (model instanceof PrimaryLinkModel) {
    return <PrimaryLink model={model} onClick={onClick} menuTitle={menuTitle} />;
  } else if (model instanceof SecondaryLinkModel) {
    return <SecondaryLink model={model} onClick={onClick} menuTitle={menuTitle} />;
  } else if (model instanceof SecondaryLinkWithBoldModel) {
    return <SecondaryLinkWithBold model={model} onClick={onClick} menuTitle={menuTitle} />;
  } else if (model instanceof ImageLinkModel) {
    return <ImageLink model={model} onClick={onClick} />;
  }
  return null;
};

export default MenuLink;
